<div class="building-setup-wrapper">
    <div class="sidenav" *ngIf="showNavigation()">
        <ul class="main-items-list">
            <li (click)="step = '1'">
                Corporation Details <i class="fa fa-check m-l-sm"></i>
            </li>
            <li *ngIf="managementServices[4].checked"
                (click)="step = '5'"
                [ngClass]="{'active': stepMoreThan(3) && stepLessThan(14)}">
                Amenities <i class="fa fa-check m-l-sm" *ngIf="stepMoreThan(13)"></i>
            </li>
            <li *ngIf="managementServices[4].checked">
                <ul *ngIf="stepMoreThan(3) && stepLessThan(14)">
                    <li *ngFor="let amenity of (amenitiesList | filterByPropertyPipe: true: 'bookable') | filterByPropertyPipe: true: 'checked'"
                        [ngClass]="{'active': selectedAmenity.name == amenity.name}"
                        (click)="selectAmenityFromNavigation(amenity)">
                        {{amenity.displayName}}
                        <i class="fa fa-check m-l-sm" *ngIf="amenity.setupCompleted"></i>
                    </li>
                </ul>
            </li>
            <li *ngIf="managementServices[5].checked"
                [ngClass]="{'active': stepMoreThan(13) && stepLessThan(21)}"
                (click)="step = allAmenitiesAreCompleted() ? '14' : step">
                Parking <i class="fa fa-check m-l-sm" *ngIf="stepMoreThan(19)"></i>
            </li>
            <li *ngIf="securityServices[0].checked"
                (click)="step = allAmenitiesAreCompleted() ? '21' : step"
                [ngClass]="{'active': stepMoreThan(20) && stepLessThan(26)}">
                Parcels <i class="fa fa-check m-l-sm" *ngIf="stepMoreThan(25)"></i>
            </li>
            <!--<li>Data Import</li>-->
        </ul>
    </div>
    <mat-card class="text-center" *ngIf="step == '1'">
        <h2 class="bold m-b-md">What are the services you use?</h2>

        <button class="btn btn-outer-primary mtv-primary-color mtv-primary-border m-b-sm"
                style="width: 160px;"
                color="primary"
                type="button"
                (click)="enableAllServices()">
            Enable All Services
        </button>

        <div class="service-list">
            <div *ngFor="let ms of managementServices" class="service-list-item">
                <mat-slide-toggle [(ngModel)]="ms.checked"
                                  class="pull-right"
                                  [disabled]=" ms.name == 'bldn' && !propertyService.userIsSuperAdmin()">
                </mat-slide-toggle>
                {{ms.displayName}}
            </div>
            <div *ngFor="let ss of securityServices" class="service-list-item">
                <mat-slide-toggle [(ngModel)]="ss.checked" class="pull-right"></mat-slide-toggle>
                {{ss.displayName}}
            </div>
        </div>
    </mat-card>
    <mat-card class="text-center" *ngIf="step == '2'" style="width: 1000px;">
        <h2 class="bold">Select Amenities you have in your building</h2>

        <table class="amenities-list text-left">
            <tr>
                <td *ngFor="let amenity of amenitiesList | slice:0:4">
                    <mat-checkbox class="font-normal" [(ngModel)]="amenity.checked">{{amenity.displayName}}</mat-checkbox>
                </td>
            </tr>
            <tr>
                <td *ngFor="let amenity of amenitiesList | slice:4:8">
                    <mat-checkbox class="font-normal" [(ngModel)]="amenity.checked">{{amenity.displayName}}</mat-checkbox>
                </td>
            </tr>
            <tr>
                <td *ngFor="let amenity of amenitiesList | slice:8:12">
                    <mat-checkbox class="font-normal" [(ngModel)]="amenity.checked">{{amenity.displayName}}</mat-checkbox>
                </td>
            </tr>
        </table>
    </mat-card>
    <mat-card class="text-center" *ngIf="step == '3'">
        <h2 class="bold m-b-lg">Which ones are bookable?</h2>

        <div class="service-list">
            <div *ngFor="let amenity of amenitiesList | filterByPropertyPipe: true: 'checked'" class="m-b-md text-left" style="padding-left: 74px;">
                <mat-checkbox class="font-normal" [(ngModel)]="amenity.bookable">{{amenity.displayName}}</mat-checkbox>
            </div>
        </div>
    </mat-card>
    <mat-card class="text-center" *ngIf="step == '4'" style="width: 610px;">
        <h2 class="bold">Based on your current selection, the process will take about 6 minutes</h2>

        <p class="m-t-lg m-b-lg">Lets setup all the parameters while its loading... Please select a corporation.</p>
    </mat-card>
    <mat-card class="text-center" *ngIf="step == '5'" style="width: 700px;">
        <h2 class="bold">{{selectedAmenity.displayName}}:</h2>
        <h2 class="bold">Let's setup the business hours</h2>

        <table class="business-hours-table" [ngClass]="{'check-in-out' : selectedAmenity.name == '4'}">
            <tr *ngFor="let timeSlot of selectedAmenity.timings; let index = index;">
                <td>
                    <mat-form-field>
                        <mat-select [(ngModel)]="timeSlot.from"
                                    (selectionChange)="onAmenityTimeChange(timeSlot, 'from')"
                                    placeholder="{{selectedAmenity.name != '4' ? 'From' : 'Check In'}}">
                            <mat-option *ngFor="let timing of timings"
                                        [value]="timing.value"
                                        [ngClass]="{'disabled' : selectedAmenity.name == '4' && isEndHourDisabled(timing.value, timeSlot.to)}"
                                        [disabled]="selectedAmenity.name == '4' && isEndHourDisabled(timing.to, timeSlot.to)">
                                {{timing.displayedValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
                <td>
                    <mat-form-field>
                        <mat-select [(ngModel)]="timeSlot.to"
                                    (selectionChange)="onAmenityTimeChange(timeSlot, 'to')"
                                    placeholder="{{selectedAmenity.name != '4' ? 'To' : 'Check Out'}}">
                            <mat-option *ngFor="let timing of timings"
                                        [value]="timing.value"
                                        [ngClass]="{'disabled' : selectedAmenity.name != '4' && isEndHourDisabled(timing.value, timeSlot.from)}"
                                        [disabled]="selectedAmenity.name != '4' && isEndHourDisabled(timing.value, timeSlot.from)">
                                {{timing.displayedValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
                <td *ngIf="selectedAmenity.name != '4'">
                    <i class="fa fa-plus-circle mtv-primary-color" aria-hidden="true" title="Add time slot" (click)="addTimeSlot()"></i>
                    <i *ngIf="selectedAmenity.timings.length > 1" class="fa fa-trash" (click)="deleteTimeSlot(index)"></i>
                </td>
            </tr>
        </table>
    </mat-card>
    <mat-card class="text-center" *ngIf="step == '6'" style="width: 700px;">
        <h2 class="bold">{{selectedAmenity.displayName}}:</h2>
        <h2 class="bold">Is there a booking limit?</h2>

        <table class="business-hours-table">
            <tr>
                <td>
                    <mat-form-field>
                        <mat-select placeholder="Limited" [(ngModel)]="selectedAmenity.limitations.limited">
                            <mat-option [value]="false">No</mat-option>
                            <mat-option [value]="true">Yes</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
                <td *ngIf="selectedAmenity.limitations.limited">
                    <mat-form-field style="width: 80px;">
                        <input matInput placeholder="Number" [(ngModel)]="selectedAmenity.limitations.number">
                    </mat-form-field>
                </td>
                <td *ngIf="selectedAmenity.limitations.limited">
                    Per Unit/Per Month
                </td>
            </tr>
        </table>
    </mat-card>
    <mat-card class="text-center" *ngIf="step == '7'" style="width: 700px;">
        <h2 class="bold">{{selectedAmenity.displayName}}:</h2>
        <h2 class="bold">How far in advance can it be booked?</h2>

        <table class="business-hours-table">
            <tr>
                <td>
                    <mat-form-field>
                        <mat-select placeholder="Limited" [(ngModel)]="selectedAmenity.advancedBooking.limited">
                            <mat-option [value]="false">Unlimited</mat-option>
                            <mat-option [value]="true">Limited</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
                <td *ngIf="selectedAmenity.advancedBooking.limited">
                    <mat-form-field style="width: 80px;">
                        <input matInput placeholder="Number" [(ngModel)]="selectedAmenity.advancedBooking.number">
                    </mat-form-field>
                </td>
                <td *ngIf="selectedAmenity.advancedBooking.limited">
                    <mat-form-field style="max-width: 130px;">
                        <mat-select placeholder="Period" [(ngModel)]="selectedAmenity.advancedBooking.period">
                            <mat-option *ngFor="let interval of timeIntervals | slice:2:6" [value]="interval.name">{{interval.displayName}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
            </tr>
        </table>
    </mat-card>
    <mat-card class="text-center" *ngIf="step == '8'" style="width: 800px;">
        <h2 class="bold">{{selectedAmenity.displayName}}:</h2>
        <h2 class="bold">Is there any gap required between bookings?</h2>

        <table class="business-hours-table">
            <tr>
                <td>
                    <mat-form-field>
                        <mat-select placeholder="Limited" [(ngModel)]="selectedAmenity.bookingDistance.required">
                            <mat-option [value]="false">Unlimited</mat-option>
                            <mat-option [value]="true">Limited</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
                <td *ngIf="selectedAmenity.bookingDistance.required">
                    <mat-form-field style="width: 80px;">
                        <input matInput placeholder="Number" [(ngModel)]="selectedAmenity.bookingDistance.number">
                    </mat-form-field>
                </td>
                <td *ngIf="selectedAmenity.bookingDistance.required">
                    <mat-form-field style="max-width: 130px;">
                        <mat-select placeholder="Period" [(ngModel)]="selectedAmenity.bookingDistance.period">
                            <mat-option *ngFor="let interval of timeIntervals" [value]="interval.name">{{interval.displayName}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
            </tr>
        </table>
    </mat-card>
    <mat-card class="text-center" *ngIf="step == '9'" style="width: auto;">
        <h2 class="bold">{{selectedAmenity.displayName}}:</h2>
        <h2 class="bold">Is there payment required to book?</h2>

        <div class="m-t-xl">
            <mat-form-field>
                <mat-select placeholder="Has payments" [(ngModel)]="selectedAmenity.paymentDetails.hasPayments">
                    <mat-option [value]="false">No</mat-option>
                    <mat-option [value]="true">Yes</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <table class="business-hours-table m-n" *ngIf="selectedAmenity.paymentDetails.hasPayments">
            <tr *ngFor="let payment of selectedAmenity.paymentDetails.payments; let index = index;">
                <td class="text-left">
                    <mat-form-field style="width: 180px;">
                        <input matInput placeholder="Fee Name" [(ngModel)]="payment.name">
                    </mat-form-field>
                </td>
                <td class="text-left">
                    <mat-form-field style="width: 80px;">
                        <input matInput
                               placeholder="$ Amount"
                               [(ngModel)]="payment.amount"
                               (keypress)="validateValue($event)">
                    </mat-form-field>
                </td>
                <td *ngIf="selectedAmenity.name == '4'">
                    <mat-form-field style="max-width: 130px;">
                        <mat-select placeholder="Per"
                                    [(ngModel)]="payment.pmtAtTime"
                                    (selectionChange)="onChargePeriodChange($event, payment)">
                            <mat-option [value]="1">Per Day</mat-option>
                            <mat-option [value]="0">Per Booking</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
                <td>
                    <mat-checkbox class="font-normal"
                                  [(ngModel)]="payment.refundable"
                                  (change)="onRefundableChange($event, payment)">
                        Payment Refundable
                    </mat-checkbox>
                </td>
                <td>
                    <i class="fa fa-plus-circle mtv-primary-color" aria-hidden="true" title="Add time slot" (click)="addPayment()"></i>
                    <i *ngIf="selectedAmenity.paymentDetails.payments.length > 1" class="fa fa-trash" (click)="deletePayment(index)"></i>
                </td>
            </tr>
        </table>
    </mat-card>
    <mat-card class="text-center" *ngIf="step == '10'" style="width: auto;">
        <h2 class="bold">{{selectedAmenity.displayName}}:</h2>
        <h2 class="bold">What payment methods do you accept?</h2>

        <div class="m-t-lg">
            <mat-checkbox class="m-r-lg font-normal" [(ngModel)]="selectedAmenity.paymentDetails.acceptedPayments.cheque">Cheque</mat-checkbox>
            <mat-checkbox class="font-normal" [(ngModel)]="selectedAmenity.paymentDetails.acceptedPayments.creditCard">Credit Card</mat-checkbox>
        </div>
    </mat-card>
    <mat-card class="text-center" *ngIf="step == '11'" style="width: 650px;">
        <h2 class="bold">{{selectedAmenity.displayName}}:</h2>
        <h2 class="bold">What agreement do you want to use?</h2>

        <div class="agreement-types">
            <div (click)="selectedAmenity.useStandartTermsAndAgreement = true;"
                 [ngClass]="{'active': selectedAmenity.useStandartTermsAndAgreement}">
                Standard
            </div>
            <div (click)="selectedAmenity.useStandartTermsAndAgreement = false;"
                 [ngClass]="{'active': !selectedAmenity.useStandartTermsAndAgreement}">
                My Own
            </div>
        </div>
    </mat-card>
    <mat-card class="text-center" *ngIf="step == '12'"
              style="width: auto; max-height: calc(100vh - 180px); overflow: auto; margin-top: 50px;">
        <h2 class="bold">{{selectedAmenity.displayName}}:</h2>
        <h2 class="bold" *ngIf="selectedAmenity.useStandartTermsAndAgreement">Here is a standard agreement</h2>
        <h2 class="bold" *ngIf="!selectedAmenity.useStandartTermsAndAgreement">Here is a custom agreement</h2>

        <div class="terms-wrapper">
            <h3 class="bold" style="margin-bottom: 20px;font-size: 22px;">Please Review the User Terms of Service</h3>
            <div class="form-group" id="summernote">
                {{selectedAmenity.useStandartTermsAndAgreement ? selectedAmenity.terms : selectedAmenity.customTerms}}
            </div>
        </div>

        <!--<div class="terms-wrapper" *ngIf="!useStandartTermsAndAgreement && !amenityTermsPdfSrc">-->
            <!--<div fileDrop-->
                 <!--class="drop-zone"-->
                 <!--[ngClass]="{'file-is-over my-drop-zone': fileIsOver}"-->
                 <!--[options]="options"-->
                 <!--(onFileDrop)="onFileDrop($event, selectedAmenity.customTerms)"-->
                 <!--(fileOver)="fileOver($event)">-->
                <!--<div>-->
                    <!--<i class="fa fa-cloud-upload fa-4x" aria-hidden="true"></i><br>-->
                    <!--Drag and Drop or-->
                    <!--<span class="mtv-primary-color clickable-text" (click)="clickFileInput()">-->
                        <!--browse-->
                    <!--</span>-->
                <!--</div>-->
            <!--</div>-->
            <!--<input id="fileInput"-->
                   <!--name="fileInput"-->
                   <!--type="file"-->
                   <!--class="hidden"-->
                   <!--(change)="onFileInput($event, selectedAmenity.customTerms)">-->
        <!--</div>-->
        <!--<div class="pdf-wrapper" *ngIf="!useStandartTermsAndAgreement && amenityTermsPdfSrc">-->
            <!--<pdf-viewer [src]="amenityTermsPdfSrc" [page]="pdfPage" [zoom]="0.6" [fit-to-page]="true"-->
                        <!--(after-load-complete)="callBackFn($event)"-->
                        <!--[show-all]="false" [render-text]="true" style="display: block;">-->
            <!--</pdf-viewer>-->
            <!--<button mat-mini-fab class="pdf-page-button" style="margin-right: 100px;" (click)="showPreviousPdfPage()">-->
                <!--<i class="fa fa-arrow-left i-arrow mtv-primary-color"></i>-->
            <!--</button>-->
            <!--<button mat-mini-fab class="pdf-page-button" (click)="showNextPdfPage()">-->
                <!--<i class="fa fa-arrow-right i-arrow mtv-primary-color"></i>-->
            <!--</button>-->
        <!--</div>-->

        <div class="agreement-wrapper">
            <textarea placeholder="I acknowledge ..."
                      resizable="false"
                      [(ngModel)]="selectedAmenity.agreement"
                      [disabled]="selectedAmenity.useStandartTermsAndAgreement"
                      maxlength="65535">
            </textarea>
        </div>
    </mat-card>
    <mat-card class="text-center" *ngIf="step == '13'" style="width: 715px;">
        <h2 class="bold">Congratulations! You have successfully set your amenities.</h2>

        <p class="m-t-md m-b-md">Lets move to the next step</p>
    </mat-card>
    <mat-card class="text-center" *ngIf="step == '14'" style="width: 680px;">
        <h2 class="bold">Is there a visitors parking in your condo?</h2>

        <mat-form-field>
            <mat-select placeholder="Has visitor parking" [(ngModel)]="hasVisitorParking">
                <mat-option [value]="false">No</mat-option>
                <mat-option [value]="true">Yes</mat-option>
            </mat-select>
        </mat-form-field>
    </mat-card>
    <mat-card class="text-center" *ngIf="step == '15'" style="width: 750px;">
        <h2 class="bold">Do you require visitors to register and get a parking pass?</h2>

        <mat-form-field>
            <mat-select placeholder="Require" [(ngModel)]="requireVisitorsToRegister">
                <mat-option [value]="false">No</mat-option>
                <mat-option [value]="true">Yes</mat-option>
            </mat-select>
        </mat-form-field>
    </mat-card>
    <mat-card class="text-center" *ngIf="step == '16'" style="width: 800px;">
        <h2 class="bold">Here are some frequent pass types we often see, select which ones are used in your condo:</h2>

        <table class="business-hours-table">
            <tr *ngFor="let rule of parkingPassRules">
                <td>
                    <mat-checkbox class="font-normal" name="{{rule.name }}" [(ngModel)]="rule.checked" (change)="choosePassRule($event)">
                        {{rule.displayName}}
                    </mat-checkbox>
                </td>
                <td>
                    <mat-form-field *ngIf="rule.name != '24' && rule.checked">
                        <mat-select placeholder="From"
                                    [(ngModel)]="rule.from"
                                    (selectionChange)="rule.to = ''">
                            <mat-option *ngFor="let timing of timings" [value]="timing.value">{{timing.displayedValue}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
                <td>
                    <mat-form-field *ngIf="rule.name != '24' && rule.checked">
                        <mat-select placeholder="To" [(ngModel)]="rule.to">
                            <mat-option *ngFor="let timing of timings"
                                        [value]="timing.value"
                                        [ngClass]="{'disabled' : rule.name == 'day' && isEndHourDisabled(timing.value, rule.from)}"
                                        [disabled]="rule.name == 'day' && isEndHourDisabled(timing.value, rule.from)">
                                {{timing.displayedValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
            </tr>
        </table>
    </mat-card>
    <mat-card class="text-center" *ngIf="step == '17'" style="width: 815px;">
        <h2 class="bold">Is there a limit of monthly passes for a single unit?</h2>

        <table class="business-hours-table">
            <tr>
                <td>
                    <mat-form-field>
                        <mat-select placeholder="Limited" [(ngModel)]="parkingPassLimitations.limited">
                            <mat-option [value]="false">No</mat-option>
                            <mat-option [value]="true">Yes</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
                <td *ngIf="parkingPassLimitations.limited">
                    <mat-form-field style="width: 80px;">
                        <input matInput placeholder="Number" [(ngModel)]="parkingPassLimitations.number">
                    </mat-form-field>
                </td>
                <td *ngIf="parkingPassLimitations.limited">
                    Per Month
                </td>
            </tr>
        </table>
    </mat-card>
    <mat-card class="text-center" *ngIf="step == '18'" style="width: 650px;">
        <h2 class="bold">What agreement do you want to use?</h2>

        <div class="agreement-types">
            <div (click)="useStandartTermsAndAgreementForParkingPass = true;"
                 [ngClass]="{'active': useStandartTermsAndAgreementForParkingPass}">
                Standard
            </div>
            <div (click)="useStandartTermsAndAgreementForParkingPass = false;"
                 [ngClass]="{'active': !useStandartTermsAndAgreementForParkingPass}">
                My Own
            </div>
        </div>
    </mat-card>
    <mat-card class="text-center" *ngIf="step == '19'" style="width: auto; max-height: calc(100vh - 180px); overflow: auto; margin-top: 50px;">
        <h2 class="bold" *ngIf="useStandartTermsAndAgreementForParkingPass">Here is a standard disclaimer</h2>
        <h2 class="bold" *ngIf="!useStandartTermsAndAgreementForParkingPass">Here is a custom disclaimer</h2>

        <div class="terms-wrapper">
            <h3 class="bold" style="margin-bottom: 20px;font-size: 22px;">Please Review the Disclaimer</h3>
            <div class="form-group" id="summernote">{{parkingPassCustomTerms}}</div>
        </div>

        <!--<div class="terms-wrapper" *ngIf="!useStandartTermsAndAgreementForParkingPass && !parkingTermsPdfSrc" style="height: 65vh;">-->
            <!--<div fileDrop-->
                 <!--class="drop-zone"-->
                 <!--[ngClass]="{'file-is-over my-drop-zone': fileIsOver}"-->
                 <!--[options]="options"-->
                 <!--(onFileDrop)="onFileDrop($event, parkingPassCustomTerms)"-->
                 <!--(fileOver)="fileOver($event)">-->
                <!--<div>-->
                    <!--<i class="fa fa-cloud-upload fa-4x" aria-hidden="true"></i><br>-->
                    <!--Drag and Drop or-->
                    <!--<span class="mtv-primary-color clickable-text" (click)="clickFileInput()">-->
                        <!--browse-->
                    <!--</span>-->
                <!--</div>-->
            <!--</div>-->
            <!--<input id="fileInput"-->
                   <!--name="fileInput"-->
                   <!--type="file"-->
                   <!--class="hidden"-->
                   <!--(change)="onFileInput($event, parkingPassCustomTerms)">-->
        <!--</div>-->
        <!--<div class="pdf-wrapper" *ngIf="!useStandartTermsAndAgreementForParkingPass && parkingTermsPdfSrc">-->
            <!--<pdf-viewer [src]="parkingTermsPdfSrc" [page]="pdfPage" [zoom]="0.6" [fit-to-page]="true"-->
                        <!--(after-load-complete)="callBackFn($event)"-->
                        <!--[show-all]="false" [render-text]="true" style="display: block;">-->
            <!--</pdf-viewer>-->
            <!--<button mat-mini-fab class="pdf-page-button" style="margin-right: 100px;" (click)="showPreviousPdfPage()">-->
                <!--<i class="fa fa-arrow-left i-arrow mtv-primary-color"></i>-->
            <!--</button>-->
            <!--<button mat-mini-fab class="pdf-page-button" (click)="showNextPdfPage()">-->
                <!--<i class="fa fa-arrow-right i-arrow mtv-primary-color"></i>-->
            <!--</button>-->
        <!--</div>-->
    </mat-card>
    <mat-card class="text-center" *ngIf="step == '20'" style="width: 715px;">
        <h2 class="bold">Congratulations! You have successfully set your parking.</h2>

        <p class="m-t-md m-b-md">Lets move to the next step</p>
    </mat-card>
    <mat-card class="text-center" *ngIf="step == '21'" style="width: 660px;">
        <h2 class="bold">Do you or the concierge receive parcels on behalf of the residents?</h2>

        <mat-form-field>
            <mat-select placeholder="Receive" [(ngModel)]="receiveParcelsOnBehalf">
                <mat-option [value]="false">No</mat-option>
                <mat-option [value]="true">Yes</mat-option>
            </mat-select>
        </mat-form-field>
    </mat-card>
    <mat-card class="text-center" *ngIf="step == '22'" style="width: 680px;">
        <h2 class="bold">Do you require residents to sign a waiver that authorises you or the concierge to receive the packages on their behalf?</h2>

        <mat-form-field>
            <mat-select placeholder="Require" [(ngModel)]="requireToSignParcelsWaiver">
                <mat-option [value]="false">No</mat-option>
                <mat-option [value]="true">Yes</mat-option>
            </mat-select>
        </mat-form-field>
    </mat-card>
    <mat-card class="text-center" *ngIf="step == '23'" style="width: 825px;">
        <h2 class="bold">Do you use a barcode scanner to log packages in?</h2>

        <mat-form-field>
            <mat-select placeholder="Require" [(ngModel)]="useBarCodeScanner">
                <mat-option [value]="false">No we do it manually</mat-option>
                <mat-option [value]="true">Yes</mat-option>
            </mat-select>
        </mat-form-field>
    </mat-card>
    <mat-card class="text-center" *ngIf="step == '24'" style="width: 690px;">
        <h2 class="bold">Do you use a signature pad to record that someone picked up the package?</h2>

        <mat-form-field>
            <mat-select placeholder="Require" [(ngModel)]="useSignaturePad">
                <mat-option [value]="false">No we do it manually</mat-option>
                <mat-option [value]="true">Yes</mat-option>
            </mat-select>
        </mat-form-field>
    </mat-card>
    <mat-card class="text-center" *ngIf="step == '25'" style="width: 715px;">
        <h2 class="bold">Congratulations! You have successfully set parcels settings.</h2>

        <p class="m-t-md m-b-md">Lets move to the next step</p>
    </mat-card>
    <mat-card class="text-center" *ngIf="step == '26'" style="width: 715px;">
        <h2 class="bold">Congratulations! You have successfully set your building.</h2>

        <p class="m-t-md m-b-md">You are now ready to start using Max Condo Club</p>
    </mat-card>
    <mat-card class="text-center" *ngIf="step.indexOf('spinner') != -1">
        <h2 class="bold">Thank You</h2>

        <div class="spinner-wrapper">
            <spinner [spinnerShow]="true"></spinner>
        </div>

        <p *ngIf="step == 'spinner1'">Polishing pixels...</p>
        <p *ngIf="step == 'spinner2'">Downloading colors from the nearest rainbow...</p>
        <p *ngIf="step == 'spinner3'">Winding Up the Countdown timers...</p>
        <p *ngIf="step == 'spinner4'">Dotting 'i's and crossing 't's...</p>
    </mat-card>
    <div class="bottom-buttons-row">
        <button class="btn btn-outer-primary mtv-primary-color mtv-primary-border"
                color="primary"
                type="button"
                [disabled]="previousButtonIsDisabled"
                (click)="goBack()">
            Previous
        </button>
        <!--<mat-progress-bar mode="determinate" [value]="currentProgress"></mat-progress-bar>-->
        <button class="btn btn-primary"
                color="primary"
                type="button"
                style="position: absolute; right: 40px;"
                mat-raised-button
                [disabled]="nextButtonIsDisabled"
                (click)="nextStep()">Continue</button>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/building-setup/building-setup.component.html